import { computed, ref, unref } from 'vue-demi'
import { useEventListener } from '@vueuse/core'

const userHelper = {
  capitalizeName (name) {
    const words = name.split(' ')
    const capWords = []
    words.forEach(word => {
      capWords.push(word.charAt(0).toUpperCase() + word.slice(1))
    })
    return capWords.join(' ')
  },

  getUserName (username = '', displayName) {
    if (displayName) return displayName
    try {
      const indexOfAt = username.indexOf('@')
      if (indexOfAt > 0) {
        return this.capitalizeName(
          username.substring(0, indexOfAt).replace('_', ' '),
        )
      } else {
        return this.capitalizeName(username.replace('_', ' '))
      }
    } catch (err) {
      throw err
    }
  },

  isIOSMobile: (ua = window.navigator.userAgent) => {
    return unref(ua).match(/\b(iPod|iPhone|iPad)\b/)
  },
  formatBytes: (a, b) => {
    if (!a) return '0 Bytes'
    var c = 1024
    var d = b || 2
    var e = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    var f = Math.floor(Math.log(a) / Math.log(c))
    return parseFloat((a / Math.pow(c, f)).toFixed(d)) + ' ' + e[f]
  },
  useMobileUA () {
    const innerWidth = ref(window.innerWidth)
    const innerHeight = ref(window.innerHeight)
    const ua = ref(window.navigator.userAgent)
    const isAndroidMobile = computed(() => unref(ua).match(/\bAndroid\b/))
    const isIosMobile = computed(() => userHelper.isIOSMobile(ua))
    const isIphone = computed(() => unref(ua).match(/\biPhone\b/))
    const isIpad = computed(() => unref(ua).match(/\biPad\b/))
    const isMobile = computed(() => unref(isIosMobile) || unref(isAndroidMobile))
    const isLandscape = computed(() => unref(innerWidth) > unref(innerHeight))
    const isPortrait = computed(() => !unref(isLandscape))
    function updateSize () {
      innerWidth.value = window.innerWidth
      innerHeight.value = window.innerHeight
    }
    function updateUa () {
      ua.value = window.navigator.userAgent
    }
    useEventListener(window, 'resize', () => {
      updateSize()
      updateUa()
    })
    return {
      isAndroidMobile,
      isIosMobile,
      isIphone,
      isIpad,
      isMobile,
      isLandscape,
      isPortrait,
    }
  },
}

export default userHelper
